import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectActiveUser } from '@store/selectors/user/user.selectors';
import { Store } from '@ngrx/store';

interface PatientActionParams extends ICellRendererParams {
  showCreateTicket: boolean;
  showValidate: boolean;
  showInspect?: boolean;
  isValidated: boolean;
  validationTooltip?: string;
}

@Component({
  selector: 'app-patient-action-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule
  ],
  templateUrl: './patient-action-renderer.component.html',
  styleUrls: ['./patient-action-renderer.component.css']
})
export class PatientActionRendererComponent implements ICellRendererAngularComp {

  params!: PatientActionParams;

  agInit(params: PatientActionParams): void {
    this.params = params;
  }

  refresh(params: PatientActionParams): boolean {
    this.params = params;
    return true;
  }

  openActionMenu(event: Event): void {
    event.stopPropagation();
  }

  handleAction(action: string): void {
    if (this.params.context && this.params.context.componentParent) {
      if (action === 'createTicket') {
        this.params.context.componentParent.createTicket(this.params.data);
      } else if (action === 'validate') {
        this.params.context.componentParent.validatePatient(this.params.data);
      } else if (action === 'inspect') {
        this.params.context.componentParent.openInspectModal(this.params.data);
      }
    }
  }

  getValidationIcon(): string {
    return this.params.isValidated ? 'remove_circle' : 'check_circle';
  }

  getValidationMenuText(): string {
    return this.params.isValidated ? 'Remove Validation' : 'Validate Patient';
  }
}